import { useHomeStore } from '../../store/home-store';
import { ViewLightningEmptyIcon } from '@/client/assets';
import { Button } from '@/client/components/ui/button';
import { useTranslation } from 'react-i18next';

type LightningEmptyProps = {
  title?: string;
  desc?: string;
  showButton?: boolean;
};
export const LightningEmpty = ({ title, desc, showButton = true }: LightningEmptyProps) => {
  const { t } = useTranslation();
  const setCategory = useHomeStore(state => state.setCategory);
  return (
    <div className="w-full p-4 flex flex-col items-center justify-center h-full space-y-3 min-h-80">
      <ViewLightningEmptyIcon className="size-[96px] fill-current" />
      <h3 className="font-semibold text-8 leading-10">{title}</h3>
      <p className="text-sm font-medium">{desc}</p>
      {showButton && (
        <Button
          variant="outline"
          className="w-[118px] h-[28px] px-4 py-2 text-xs font-medium rounded-full"
          onClick={() => setCategory('trending')}
        >
          {t('explore-trending')}
        </Button>
      )}
    </div>
  );
};
